import { AnyRoute, useNavigate } from '@tanstack/react-router';
import * as React from 'react';

export function useSetSearch<T>(_?: T) {
  const navigate = useNavigate();

  return React.useCallback(
    (query: Partial<T extends AnyRoute ? T['types']['searchSchema'] : T>, replace?: boolean) => {
      void navigate({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        search: (search) => ({
          ...search,
          ...query,
        }),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        params: (current) => current,
        replace,
      });
    },
    [navigate],
  );
}
